<template>
  <AIAssistantBaseChatResponse>
    <div class="tw:grid tw:gap-4">
      <AIAssistantBaseChatType @complete="showOptions = true">
        {{ message.message }}
      </AIAssistantBaseChatType>

      <AIAssistantBaseChatTransition
        v-if="showOptions && message.options.length"
        appear
        class="tw:grid tw:gap-1"
      >
        <div
          v-for="(option, optionIndex) in message.options"
          :key="optionIndex"
          :data-index="optionIndex"
        >
          <AIAssistantBaseOption
            :icon="option.icon"
            :icon-class="option.iconClass"
            @click="emit('suggestion', option.label)"
          >
            <div class="tw:flex tw:gap-2">
              <div>
                {{ option.label }}
              </div>
              <div v-if="option.tooltipText">
                <BaseIcon icon="info" />
                <StreemTooltip>
                  {{ option.tooltipText }}
                </StreemTooltip>
              </div>
            </div>
          </AIAssistantBaseOption>
        </div>
      </AIAssistantBaseChatTransition>
    </div>
  </AIAssistantBaseChatResponse>
</template>

<script setup lang="ts">
import { ref } from "vue";

import AIAssistantBaseChatResponse from "shared/components/AI/AIAssistant/AIAssistantBaseChatResponse.vue";
import AIAssistantBaseChatTransition from "shared/components/AI/AIAssistant/AIAssistantBaseChatTransition.vue";
import AIAssistantBaseChatType from "shared/components/AI/AIAssistant/AIAssistantBaseChatType.vue";
import AIAssistantBaseOption from "shared/components/AI/AIAssistant/AIAssistantBaseOption.vue";
import { BaseIcon, StreemTooltip } from "shared/components/base";
import { type AIAssistantSuggestMessage } from "shared/composables/useAIAssistant";

interface AIAssistantBaseChatSuggestMessageProps {
  message: AIAssistantSuggestMessage;
}

defineProps<AIAssistantBaseChatSuggestMessageProps>();

const emit = defineEmits<{
  suggestion: [string];
}>();

const showOptions = ref<boolean>(false);
</script>
